import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ColorConfig, UserDetails } from "../models/UserDetails";
import { SportDetails } from "../models/SportsDetails";
import { SiteConfig } from "../models/SiteConfig";

export interface UserDetailsDTO {
  userDetails: UserDetails;
  siteConfig: SiteConfig;
  wallets: any;
  sportsExchData: any;
  sportSBData: any;
  casinoData: any;
  homeData: any;
  banners: any;
  activeWallet: any;
  Thumbnail: any;
  lobby: string;
  exchData: SportDetails;
  sbData: SportDetails;
  logout: boolean;
  isLoggedIn: boolean;
  Browser: string;
  colorConfig: ColorConfig;
  gameSessionId: string; // Single session ID shared across games
  gameSessionUrl: string; // Single session URL shared across games
}

// Define the initial state
const initialState: UserDetailsDTO = {
  userDetails: {
    EmailId: "",
    IsAffiliator: false,
    MobileNumber: "",
    ReferralCode: "",
    ReferralCount: 0,
    ReferrerId: "",
    Status: "",
    UserKey: "",
    UserName: "",
    ActiveWallet: "",
    Theme: "",
    Thumbnail: "",
    Wager: 0,
    WithdrawAmount: 0,
    IsClassic: false,
    language: "English",
    IsPremium: false,
    telegramLink: "",
    BlockUserPayments: false,
    BlockBonus: false,
    IsContactOptional: false,
    BlockReferrals: false,
    disableDefaultTheme:false,
    exchangeProvider: "",
    sportsbookProvider: "",
    botId: "",
    userOrigin: "",
  },
  siteConfig: {
    isPrivate: false,
    isContactOptional: false,
    blockReferrals: false,
    blockBonus: false,
    blockUserPayments: false,
    isSportsEnabled: true,
    isCasinoEnabled: true,
    isSitesEnabled: true,
    disableDefaultTheme: false,
    demoLogin: false,
    contactInfo: {
      Facebook: "",
      Instagram: "",
      TelegramChannel: "",
      WhatsappSignup: "",
      WhatsappSupport: "",
      EnableCustomerSupport: false,
    },
  },
  wallets: [],
  sportsExchData: [],
  sportSBData: [],
  casinoData: [],
  homeData: [],
  banners: [],
  activeWallet: "",
  Thumbnail: "",
  lobby: "EXCHANGE",
  exchData: {
    providerId: "",
    token: "",
    operatorId: "",
    partnerId: "",
    currency: "",
    rate: 0,
  },
  sbData: {
    providerId: "",
    token: "",
    operatorId: "",
    partnerId: "",
    currency: "",
    rate: 0,
  },
  logout: false,
  isLoggedIn: false,
  Browser: "",
  colorConfig:{
    activeButton:"",
    background:"",
    backgroundTeamInfo:"",
    filterColor:"",
    inputBackgroundBox:"",
    inputBorderBox:"",
    primary:"",
    primaryTeamInfo:"",
    subHeaderColor:"",
    tableBackground:"",
    tableBorder:"",
    tableHeader:"",
    text:"",
  },
  gameSessionId: "",
  gameSessionUrl: "",
};

// Create a slice of the state with actions and reducers
const authSlice = createSlice({
  name: "userDetails",
  initialState,
  reducers: {
    setUserDetails(state, action: PayloadAction<Partial<UserDetails>>) {
      state.userDetails = { ...state.userDetails, ...action.payload };
    },
    setSiteConfig(state, action: PayloadAction<Partial<SiteConfig>>) {
      state.siteConfig = { ...state.siteConfig, ...action.payload };
    },
    setWallets(state, action: PayloadAction<any[]>) {
      state.wallets = action.payload;
    },
    setSportsExchData(state, action: PayloadAction<any[]>) {
      state.sportsExchData = action.payload;
    },
    setSportsSBData(state, action: PayloadAction<any[]>) {
      state.sportSBData = action.payload;
    },
    setCasinoData(state, action: PayloadAction<any[]>) {
      state.casinoData = action.payload;
    },
    setHomeData(state, action: PayloadAction<any[]>) {
      state.homeData = action.payload;
    },
    setBanners(state, action: PayloadAction<any[]>) {
      state.banners = action.payload;
    },
    setActiveWallet(state, action: PayloadAction<any>) {
      state.activeWallet = action.payload;
    },
    setUserThumbnail(stage, action: PayloadAction<any>) {
      stage.Thumbnail = action.payload;
    },
    setLobby(stage, action: PayloadAction<any>) {
      stage.lobby = action.payload;
    },
    setUserName(state, action: PayloadAction<any>) {
      state.userDetails.UserName = action.payload;
    },
    setExchangeAuthData(state, action: PayloadAction<any>) {
      state.exchData = action.payload;
    },
    setSportBookAuthData(state, action: PayloadAction<any>) {
      state.sbData = action.payload;
    },
    setLogout(state, action: PayloadAction<any>) {
      state.logout = action.payload;
    },
    setSportView(state, action: PayloadAction<any>) {
      state.userDetails.IsClassic = action.payload;
    },
    setIsLoggedIn(state, action: PayloadAction<any>) {
      state.isLoggedIn = action.payload
    },
    setBrowser(state, action: PayloadAction<any>) {
      state.Browser = action.payload
    },
    setColorConfig(state, action: PayloadAction<Partial<ColorConfig>>) {
      state.colorConfig = { ...state.colorConfig, ...action.payload };
    },
    setGameSessionId(state, action: PayloadAction<string>) {
      state.gameSessionId = action.payload;
    },
    setGameSessionUrlSingle(state, action: PayloadAction<string>) {
      state.gameSessionUrl = action.payload;
    },
    clearGameSession(state) {
      state.gameSessionId = "";
      state.gameSessionUrl = "";
    },
    // Define other reducers here if needed
  },
});

// Export the actions generated by createSlice
export const { setUserDetails, setSiteConfig, setWallets, setSportsExchData, setSportsSBData, setCasinoData, setHomeData, setBanners, setActiveWallet, setUserThumbnail, setUserName, setExchangeAuthData, setSportBookAuthData, setLobby, setLogout, setSportView, setIsLoggedIn, setBrowser, setColorConfig, setGameSessionId, setGameSessionUrlSingle, clearGameSession } = authSlice.actions;

// Export the reducer to be used in the store
export default authSlice.reducer;
